import { render, staticRenderFns } from "./CalendarChampionshipLargeItemComponent.vue?vue&type=template&id=7db53f6b&scoped=true"
import script from "./CalendarChampionshipLargeItemComponent.vue?vue&type=script&lang=ts"
export * from "./CalendarChampionshipLargeItemComponent.vue?vue&type=script&lang=ts"
import style0 from "./CalendarChampionshipLargeItemComponent.vue?vue&type=style&index=0&id=7db53f6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db53f6b",
  null
  
)

export default component.exports